import React, { Fragment } from 'react';
import NavbarContainer from 'shared/containers/NavbarContainer';
import DashboardContainer from 'bundles/Dashboard/containers/DashboardContainer';

const DashboardScene = (props) => {
    return (
        <Fragment>
            <NavbarContainer />
            <DashboardContainer {...props} />
        </Fragment>
    );
};

export default DashboardScene;
